module.exports = __webpack_public_path__ + "static/media/FeedTime_ios_3.d03b8a0f.jpg";